"use client";
import React, { useContext,useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import HeroSection from "./HeroSection";
import FeatureCard from "./FeatureCard";
import CategoryItem from "./CategoryItem";
import PromoBanner from "./PromoBanner";
import TopSellingSection from "./TopSellingSection";
import RecentlyViewedSection from "./RecentlyViewedSection";
import QualitySection from "./QualitySection";
import Subscription from "./Subscription Plan/SubscriptionHome";
import Footer from "./Footer";
import feature1 from "./assets/feature1.png";
import feature2 from "./assets/feature2.png";
import feature3 from "./assets/feature3.jpg";
import HowItWorksSection from "./HowltWorksSection";
import { CategoryContext } from "../context/CategoryContext";
import WhyRentasticSection from "./WhyRentasticSection";
 
// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" }
};
 
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.2
    }
  }
};
 
const slideInLeft = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8, ease: "easeOut" }
};
 
const slideInRight = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8, ease: "easeOut" }
};
 
function Home() {
  const navigate = useNavigate();
    useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  const { categories, loading } = useContext(CategoryContext)
 
const handleCategoryClick = (categoryName) => {

  navigate('/products', { state: { category: categoryName } });
};

  const handleProductClick = (productId) => {
     window.scrollTo({ top: 0, behavior: 'smooth' }); 
    navigate(`/product/${productId}`);
  };
 
  const features = [
    {
      image: "https://cdn.acsdev.in/Rentastic/feature1.png",
      title: "Easy Toy Rentals",
      description: "Our collection includes educational toys that spark creativity and imagination. Build, explore, and learn — every toy is designed to make playtime smarter."
    },
    {
      image:"https://cdn.acsdev.in/Rentastic/feature2.png",
      title: "Learn Through Play",
      description: "Shop confidently with our 100% secure payment system protecting your personal and  financial  information."
    },
    {
      image:"https://cdn.acsdev.in/Rentastic/feature3.jpg",
      title: "Safe & Sustainable",
      description: "We care about your kids and the planet. Every toy is sanitized, eco-friendly, and safe for little hands — because fun should always be worry-free."
    }
  ];
 
  // const categories = [
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/33f921f13fc218d27f71acd8e1e12886ad91d472?width=180",
  //     name: "Wooden",
  //     id: "wooden"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/fd7b6ccaf5e78c2c9ea28da5d657dad7839b91e7?width=140",
  //     name: "Puzzle",
  //     id: "puzzle"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/b102df3eac1d2262714cfa89907ab39feae36c2d?width=180",
  //     name: "Stuffed",
  //     id: "stuffed"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/2fba5ef8165fcc57f05ca4bf168a8ce18589f382?width=180",
  //     name: "Smart",
  //     id: "smart"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/5ddc3cb3ae410275eea8484aa40044d966e8170f?width=180",
  //     name: "Electronic",
  //     id: "electronic"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/b2381875c73789189d172fbbecb399b1375be787?width=140",
  //     name: "Sports",
  //     id: "sports"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/5d4d3143756aaab8676547f305f825d8b1d6f834?width=183",
  //     name: "Learning",
  //     id: "learning"
  //   },
  //   {
  //     icon: "https://api.builder.io/api/v1/image/assets/TEMP/3f1f459ec30ffd667c0f7a52c57d29239d7aaca2?width=140",
  //     name: "Construction",
  //     id: "construction"
  //   }
  // ];
 
  return (
    
    <motion.main
      className="w-full bg-neutral-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
        <Header/>
      <HeroSection />
          <Subscription />
          <HowItWorksSection/>
          <WhyRentasticSection/>
  {/* <motion.section
  className="w-full flex flex-col items-center justify-center px-10 py-5 mt-1 text-center"
  aria-labelledby="features-heading"
  variants={staggerContainer}
  initial="initial"
  whileInView="animate"
  viewport={{ once: true, amount: 0.3 }}
>
  <h2
    id="features-heading"
    className="mb-16 text-5xl font-bold text-sky-950 max-sm:text-3xl"
  >
    Our Features
  </h2>

  <motion.div
    className="grid grid-cols-1 gap-12 justify-center items-center max-w-[1600px] mx-auto 
               sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
  >
    {features.map((feature, index) => (
      <motion.div key={index} variants={fadeInUp} className="flex justify-center h-full">
        <FeatureCard {...feature} />
      </motion.div>
    ))}
  </motion.div>
</motion.section> */}



 
     
 
      <motion.section
        className="px-0 py-0"
        aria-labelledby="categories-heading"
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        {/* <motion.h2
          id="categories-heading"
          className="mb-16 text-5xl font-bold text-center text-sky-950 max-sm:text-3xl"
          variants={fadeInUp}
        >
          Our Categories
        </motion.h2>
        <motion.div
          className="flex gap-5 justify-between items-center mx-auto my-0 max-w-full 2xl:max-w-[1600px] xl:max-w-[1200px]  lg:max-w-[800px] lg:justify-center xl:justify-between max-md:flex-wrap max-md:gap-6 max-md:justify-center max-sm:gap-4 max-sm:grid-cols-[repeat(2,1fr)]"
          variants={staggerContainer}
        >
          {categories.map((category, index) => (
            <motion.div key={index} variants={fadeInUp}>
              <CategoryItem {...category} />
            </motion.div>
          ))}
        </motion.div> */}
      </motion.section>
 
      {/* <motion.section
        className="flex gap-14 px-10 py-0 mb-20 max-md:flex-col max-md:gap-6 max-md:text-sm "
        aria-label="Promotional banners"
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.div variants={fadeInUp} className="flex-1">
          <PromoBanner
            image="https://cdn.acsdev.in/Rentastic/21.png"
            title="Top Rated Toys"
            subtitle="Everything For You Toys & Accessories"
            buttonColor="bg-[#4E5923]"
            textColor="text-[#4E5923] "
            onClick={() => navigate('/products')}
          />
        </motion.div>
        <motion.div variants={fadeInUp} className="flex-1">
          <PromoBanner
            image="https://cdn.acsdev.in/Rentastic/31.png"
            title="Top Rated Toys"
            subtitle="Everything For You Toys & Accessories"
            buttonColor="bg-teal-900"
            textColor="text-teal-900"
            onClick={() => navigate('/products')}
          />
        </motion.div>
      </motion.section> */}
{/*  
      <motion.div
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeInUp}
      >
        <TopSellingSection onProductClick={handleProductClick} />
      </motion.div> */}
 
      {/* <RecentlyViewedSection onProductClick={handleProductClick} /> */}

  
      {/* <motion.div
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <QualitySection />
      </motion.div> */}
       {/* Categories Section */}
       <motion.section
        className="px-10 py-20"
        aria-labelledby="categories-heading"
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <motion.h2
          id="categories-heading"
          className="mb-16 text-5xl font-bold text-center text-sky-950 max-sm:text-3xl"
          variants={fadeInUp}
        >
          Our Categories
        </motion.h2>
        <motion.div
          className="grid grid-cols-8 gap-5 mx-auto my-0 max-w-[1600px] 2xl:grid-cols-8 xl:grid-cols-8 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-3 max-sm:grid-cols-3 place-items-center"
          variants={staggerContainer}
        >
          {loading ? (
            <p className="col-span-full text-center text-gray-500">Loading categories...</p>
          ) : (
            categories.map((category) => (
              <motion.div key={category.id} variants={fadeInUp} onClick={() => handleCategoryClick(category.name)} className="cursor-pointer">
                <CategoryItem icon={category.image} name={category.name} id={category.id} />
              </motion.div>
            ))
          )}
        </motion.div>
      </motion.section>
 
      <motion.div
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <Footer />
      </motion.div>
    </motion.main>
  );
}
 
export default Home;